import { TextField } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import get from 'lodash.get';

type Props = {
  name: string;
  required?: boolean;
  fullWidth?: boolean;
  label?: string;
  onChange?: any;
  options?: any;
  type?: string;
  shrink?: boolean;
  defaultValue?: any;
  endAdornment?: any;
  disabled?: boolean;
};

const UTextField2 = (
  { name, required, fullWidth, label, onChange, options, type, shrink, defaultValue, endAdornment, disabled }: Props,
  ref: any,
) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const { onBlur, ...rest } = register(name, options);
  const _ref = rest.ref;
  const _onChange = rest.onChange;
  const error = get(errors, name);
  return (
    <TextField
      type={type}
      name={name}
      disabled={disabled}
      defaultValue={defaultValue}
      error={!!error}
      helperText={error ? error.message : null}
      label={label}
      required={required}
      fullWidth={fullWidth}
      InputLabelProps={{
        shrink: shrink === true,
      }}
      InputProps={{
        endAdornment: endAdornment,
      }}
      inputRef={(r) => {
        _ref(r);
        if (ref) {
          if (typeof ref == 'function') ref(r);
          else ref.current = r;
        }
      }}
      onChange={(evt) => {
        if (onChange) onChange(evt);
        _onChange(evt);
      }}
      onBlur={onBlur}
    />
  );
};

export default React.forwardRef(UTextField2);
